/**
 * useContactCategoryListScreen.js
 * -------------------------------
 * Headless Hook for Contact Category Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as contactCategoryApi from '../api/contactCategoryApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function useContactCategoryListScreen() {
  const master = useMasterList({
    entityName: 'Contact Category',
    apiClient: contactCategoryApi.contactCategoryClient,
    fetchList: contactCategoryApi.listContactCategories,
    archiveItem: contactCategoryApi.archiveContactCategory,
    deleteItem: contactCategoryApi.deleteContactCategory,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'contact-category',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Contact Category Master Registry',
        subtitle: 'Enterprise Stakeholder & Contact Classifications',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Category Name', accessor: 'name' },
          { header: 'Description / Scope', accessor: 'description' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
